import React from 'react';
import ReactDOM from 'react-dom';
import { Player } from '@beatport/ui/dist/cjs/Player';
import config from '@beatport/ui/dist/cjs/config';
import * as THEME from './theme';
import { Notifier } from '@beatport/ui/dist/cjs/Alerts';

const Anchor = ({ href, ...extra }) => {
  return (<a href={`https://www.beatsource.com${href}`} rel="noreferrer" target="_blank" {...extra} />)
};

config.useCustomAnchors = true;
config.Anchor = Anchor;

declare global {
  interface Window {
    BeatsourceBlocks: any;
    BeatsourceNotifier: any;
  }
}

const isNeedleDrop = false;


const player = React.createRef();
window.BeatsourceBlocks = window.BeatsourceBlocks || {}
window.BeatsourceBlocks.player = player;

const container = document.createElement('div');
container.id = 'beatsource-blocks-player';
container.classList.add('beatsource-blocks');
document.body.appendChild(container);

const PlayerArtwork = ({ playlist }) => {
  return playlist.current ? (
      <span className="Player__artwork-2">
          <img
              alt={playlist.current.name}
              key={playlist.current.uiuid}
              id={playlist.current.uiuid}
              src={playlist?.current?.release?.image?.uri}
          />
      </span>
  ) : null;
}

const PlayerWrapper : React.FC = () => {

  return (
    <>
      <Player
        ref={player}
        PlayerArtwork={PlayerArtwork}
        waveformSize="half"
        zoomEnabled={false}
        volumeFaderOrientation="horizontal"
        waveformColorMap={{
          COLOR_TRACK_PLAYED: THEME.COLOR_TRACK_PLAYED,
          COLOR_TRACK_UNPLAYED: THEME.COLOR_TRACK_UNPLAYED,
          COLOR_TRACK_AVAILABLE: isNeedleDrop
            ? THEME.COLOR_TRACK_AVAILABLE_ND_ENABLED
            : THEME.COLOR_TRACK_AVAILABLE,
          COLOR_TRACK_AVAILABLE_BG: THEME.COLOR_TRACK_AVAILABLE_BG,
          COLOR_MARKER: THEME.COLOR_MARKER,
        }}
      />
      <Notifier ref={(i) => { window.BeatsourceNotifier = i; }} bottom right />
    </>
  )
}

// @ts-ignore
ReactDOM.render(
  <PlayerWrapper />,
  container
)